module.exports = __webpack_public_path__ + "hold-music.mp3";


//////////////////
// WEBPACK FOOTER
// ./app/assets/audio/hold-music.mp3
// module id = 973
// module chunks = 0